var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-widget"},[_c('div',{staticClass:"bubble"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v("Click the icon below to get started.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }